<template>
  <div class="grey lighten-3" v-if="getBundle">
    <v-layout align-center>
      <v-flex class="pa-2 blue--text">
        <div
          class="pa-1 caption blue--text mr-2"
          style="border-radius: 5px; display: inline-block"
          :style="{
            'background-color': colors.blue.lighten5,
            border: `1px solid ${colors.blue.base}`
          }"
        >
          PRODUCT BUNDLED
        </div>
        {{
          `ซื้อ ${getBundle.quantity_condition} ชิ้น ลด ${getBundle.discount} บาท`
        }}
      </v-flex>
      <v-flex shrink class="py-1">
        <v-btn small flat color="orange" @click="handleShowBundleOption"
          >เลือกสินค้าเพิ่ม ></v-btn
        >
      </v-flex>
    </v-layout>

    <div style="overflow-y: scroll">
      <v-layout align-center>
        <v-flex style="width: 100px" class="pa-2">
          <img
            :src="
              product.photourl && product.photourl.split(';;')
                ? product.photourl.split(';;')[0]
                : ''
            "
            :lazy-src="require(`@/assets/img/products/default-photo.png`)"
            class="img-responsive grey lighten-2"
            lazy
            aspect-ratio="1"
            style="width: 100%"
          />

          <div class="text-xs-center caption truncate">
            {{ product.name || '-' }}
          </div>
          <div class="caption primary--text">
            {{ currencySign }}{{ product.price | decimalFormat }}
          </div>
        </v-flex>
        <v-flex class="pa-2" shrink>
          <v-icon>add</v-icon>
        </v-flex>

        <template v-for="(product, pindex) in getBundle.products">
          <v-flex :key="product.id" style="width: 100px" class="pa-2">
            <v-img
              :src="
                product.photourl && product.photourl.length
                  ? product.photourl[0]
                  : ''
              "
              :lazy-src="require(`@/assets/img/products/default-photo.png`)"
              class="img-responsive grey lighten-2"
              lazy
              aspect-ratio="1"
              style="width: 100%"
            />

            <div class="text-xs-center caption truncate">
              {{ product.name || '-' }}
            </div>
            <div class="caption primary--text">
              {{ currencySign }}{{ product.price | decimalFormat }}
            </div>
          </v-flex>
          <v-flex
            shrink
            :key="`split_${product.id}`"
            v-if="pindex != getBundle.products.length - 1"
          >
            {{ $t('or') }}
          </v-flex>
        </template>
      </v-layout>
    </div>
  </div>
</template>

<script>
import colors from 'vuetify/es5/util/colors'
export default {
  props: {
    product: {
      value: undefined
    }
  },
  data() {
    return {
      colors: colors
    }
  },
  computed: {
    getBundle() {
      const bundles = this.$store.getters['bundles/availableBundles']
      const matchBundle = bundles.find((bundle) => {
        return bundle.products.some((product) => product.id == this.product.id)
      })
      return matchBundle
    },

    currencySign: function () {
      if (this.product && this.product.currency) {
        return this.getCurrencyByCode(this.product.currency)
      }
      return '฿'
    }
  },
  methods: {
    handleShowBundleOption() {
      this.$store.commit('bundles/SHOW_BUNDLE_SELECT', this.getBundle)
      this.$emit('handleCloseModal')
    }
  }
}
</script>

<style lang="scss" scoped></style>
